
    import ApiButton from "@/components/ApiButton.vue";
    import BookingModal from "@/views/Modals/BookingsModals/BookingModal.vue"
    import Component from "vue-class-component";
    import ConfirmBookingModal from "@/views/Modals/BookingsModals/ConfirmBookingModal.vue"
    import EventBus from "@/utilities/EventBus";
    import MapLocationModal from "@/views/Modals/BookingsModals/MapLocationModal.vue";
    import Vue from "vue";
    import ScanReportModal from "@/views/Modals/BookingsModals/ScanReportModal.vue"
    import store from "../store/store";
    import { ApiClient } from "@/utilities/ApiClient";
    import { Booking } from "@/model/Booking";
    import { BookingSearchParameters } from "@/model/Api/Params/BookingSearchParameters";
    import { Contractor } from "@/model/Contractor";
    import { BookingSearchResult, IBookingSearchResult } from "@/model/Api/VM/BookingSearchResult";
    import { LookupItem } from "@/model/LookupItem";
    import { StateChanger } from "vue-infinite-loading";
    import { Utils } from "@/utilities/Utils";
    import { Watch } from "vue-property-decorator";
    import { Employee, IEmployee } from "@/model/Employee";
    import { User, IUser } from "@/model/User";
import { BookingVM } from "@/model/Api/VM/BookingVM";
import { icon } from "leaflet";

    @Component({
        components: {
            ApiButton,
            BookingModal,
            MapLocationModal,
            ConfirmBookingModal,
            ScanReportModal
        }
    })

    export default class Bookings extends Vue {

        async mounted() {
            this.contractor.id ? store.state.signedInContractor?.id === this.contractor.id : null;

            this.signedInUser = this.signedInUser = this.$store.state.signedInUser;

            this.loadStatusOptions();
            this.loadEmployees();

            EventBus.$on("editBooking", this.editBooking);

            if (store.state.bookingsSearchText) { this.params.searchText = store.state.bookingsSearchText; }

            if (store.state.bookingsStatusID) { this.params.statusID = store.state.bookingsStatusID; }
        }

        //
        // -- properties
        //

        private infiniteId: number = + new Date();
        booking = new Booking();
        private bookings: Array<IBookingSearchResult> = [];
        private contractor = new Contractor();
        private isLoading = false;
        private params = new BookingSearchParameters();
        private statusOptions: Array<LookupItem> = [];
        private totalCount = -1; // needs to not be zero in order to trigger first search in infiniteLoadingHandler
        private totalNumberOfBookings = 0;
        private employees: Array<IEmployee> = [];
        private signedInUser = new User();

        private get countText(): string {
            return this.totalCount === -1 ? "..." : this.totalCount.toString();
        }

        //
        // -- watchers
        //

        @Watch("params.statusID")
        onStatusIDChanged(value: number) {
            this.params.includeCompleted = false;
            if ((value === 6) || (value === 7)) this.params.includeCompleted = true
            if (value === store.state.bookingsStatusID) return;//stops refreshSearch running after selecting a status, browsing away from the bookings, and coming back to bookings
            store.dispatch("setBookingsStatusID", value);
            this.refreshSearch();
        }

        @Watch("params.searchText")
        onSearchTextChanged(value: string) { store.dispatch("setBookingsSearchText", value); }

        @Watch("params.includeCompleted")
        onIncludeCompletedChanged(value: number) {
            this.refreshSearch();
        }

        @Watch("params.employeeID")
        onEmployeeIDChanged(value: number) {
            this.refreshSearch();
        }

        //
        // -- methods
        //

        confirmDisabledText(booking: BookingSearchResult) {
            if (booking.confirmDisabled) {
                return "First stay is in the past. Contact admin to confirm."
            }
            else {
                return "Please select a preferred hotel"
            }
        }

        async infiniteLoadingHandler(stateChanger: StateChanger) {
            const contractorServerData = await ApiClient.get(`Api/Contractor/GetContractor?id=${store.state.signedInUser?.guid}`);
            this.contractor.update(contractorServerData);
            this.params.contractorID = this.contractor.id;
            const response = await ApiClient.post("/Api/Bookings/Search", this.params, event);
            if (response.list.length) {               
                this.bookings.push(...response.list.map((b: IBookingSearchResult) => new BookingSearchResult(b)));
                this.totalCount = response.count;
                this.params.pageNumber += 1;
                this.isLoading = false;
                stateChanger.loaded();
            }
            else {
                this.isLoading = false;
                stateChanger.complete();
            }         

            // if (this.bookings.length >= this.totalCount && this.totalCount > -1) {
            //     stateChanger.complete();
            //     return;
            // }
            // this.params.pageNumber += 1;
            // await this.search();
            // if (this.bookings.length >= this.totalCount) {
            //     stateChanger.complete();
            // }
            // else {
            //     stateChanger.loaded();
            // }
        }

        refreshSearch(event?: Event) {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.bookings = [];
            this.infiniteId += 1;
            this.params.pageNumber = 1;
            this.totalCount = -1;
            //this.search(event);
        }

        refreshParams() {
            Utils.resetObject(this.params);
            this.refreshSearch();
        }

        async loadStatusOptions() {
            this.statusOptions = [];
            const response = await ApiClient.get("/api/bookings/StatusOptions");
            this.statusOptions.push(...response);
        }

        async loadEmployees (event?: Event) {
            const contractorServerData = await ApiClient.get(`Api/Contractor/GetContractor?id=${store.state.signedInUser?.guid}`);
            this.contractor.update(contractorServerData);
            const response = await ApiClient.post(`Api/Employees/employees?id=${this.contractor.guid}`, event);
            this.employees.push(...response);
        }

        addNew() {
            this.$refs.bookingModal;
            const dialogue = this.$refs.bookingModal as BookingModal & { show: () => void };
            dialogue.show();
        }

        editBooking(bookingData: number) {
            if (typeof this.$refs.bookingModal == 'undefined') return;
            const dialogue = this.$refs.bookingModal as BookingModal & { editBooking: () => void };
            dialogue.editBooking(bookingData);
        }

        async downloadBookingItinerary(bookingID: number) {
            const blob: Blob = await ApiClient.get(`/api/report/bookingItinerary?id=${bookingID}`);
            Utils.downloadBlob(document, blob, `BookingItinerary_${bookingID}.pdf`);
        }

        async openMap(worksLat: number, worksLng: number,) {
            const dialogue = this.$refs.mapLocationModal as MapLocationModal & { show: () => void };
            dialogue.show(worksLat, worksLng);
        }

        openConfirmationModal(bookingData: BookingVM) {
            const dialogue = this.$refs.confirmBookingModal as ConfirmBookingModal & { showFromBookings: () => void };
            dialogue.showFromBookings(bookingData);
        }

        openScanReportModal(bookingData: Booking) {
            const dialogue = this.$refs.scanReportModal as ScanReportModal & { open: () => void };
            dialogue.open(bookingData.id);
        }

        private sortColm(field: string, direction: number) {
            this.params.sortField = field;
            this.params.sortDirection = direction;
            this.refreshSearch();
        }

    }
